
import Pagination from '@/components/pagination/index.vue';
import { getPageIndex } from '@/utils/common.js';
import Service from '../orders.service.js';
import UploadImage from '../../../socialized-service/share/upload-image/index.vue';

export default {
  components: {
    Pagination,
    UploadImage
  },
  data() {
    return {
      pageType: '',
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableList: [],
      dialogRateVisible: false,
      rateValue: 0,
      rateOrderId: '',
      dialogFormVisible: false,
      dialogFormData: {
        id: '',
        userInspectionStatus: 1,
        userInspectionRemark: '',
        userInspectionPhotos: []
      },
      rules: {
        userInspectionStatus: [
          { required: true, message: '请选择验收状态', trigger: 'change' }
        ],
        userInspectionRemark: [
          { required: true, message: '请输入不通过原因', trigger: 'blur' }
        ],
        userInspectionPhotos: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    tableEditWidth () {
      let width = 80;
      if(this.tableList.some((e) => {return ['060', '070'].includes(e.status);})){
        width = '190';
      }
      return width;
    }
  },
  watch: {
    $route: function () {
      this.pageType = this.$route.params.type;
      this.getTableList();
    }
  },
  created() {
    this.pageType = this.$route.params.type;
    this.getTableList();
  },
  methods: {
    // 序号计算
    indexMethod(index) {
      return getPageIndex(this.pageNum, this.pageSize, index);
    },

    // 获取表格数据
    getTableList(page) {
      if (page && page.pageNo && page.pageSize) {
        this.pageNum = page.pageNo;
        this.pageSize = page.pageSize;
      }
      const query = {
        code: this.pageType,
        tId: '66aaf784247b9fffdb5eba0b',
        source: 'spring_app'
      };
      query.limit = this.pageSize;
      query.skip = (this.pageNum - 1) * this.pageSize;
      this.total = 0;
      this.tableList = [];
      Service.getTrusteeshipList(query).then(res => {
        this.total = res.total;
        this.tableList = res.result;
      });
    },

    displayAddress(address) {
      const arr = address.split('-');
      return arr.slice(-2);
    },

    // 交付订单弹窗
    showDialig(item) {
      this.dialogFormVisible = true;
      this.dialogFormData.id = item._id;
    },

    showSubmitFinshed() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$confirm('您确认提交验收结果吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 验收
            this.submitFinshed();
          }).catch(() => {

          });
        }
      });
    },

    submitFinshed() {
      const formData = JSON.parse(JSON.stringify(this.dialogFormData));
      if(formData.userInspectionStatus === 1) {
        delete formData.userInspectionRemark;
      }
      Service.inspectTrusteeship(formData).then((res) => {
        if(res) {
          this.$successMessage('操作成功');
          this.getTableList();
          this.dialogFormVisible = false;
        }
      }, (error) => {
        this.dialogFormVisible = false;
        const reason = error.data && error.data.reason;
        if (reason) {
          this.$alert(reason, '提示', {
            confirmButtonText: '确定',
            callback: () => {
            }
          });
          return;
        }
      });
    },

    showCommentOrderDialog(id) {
      this.dialogRateVisible = true;
      this.rateOrderId = id;
    },

    submitRateConfim() {
      if(!this.rateValue) {
        this.$errorMessage('请进行评分');
        return;
      }
      this.$confirm('您确定提交评分吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 评分
        this.submitRate({id: this.rateOrderId, score: this.rateValue});
      }).catch((err) => {
        console.log('【error】', err);
      });
    },

    submitRate(params) {

      Service.commentOrder(params).then((res) => {
        if(res) {
          this.$successMessage('操作成功');
          this.getTableList();
        }
        this.dialogRateVisible = false;
      }, (error) => {
        this.dialogRateVisible = false;
        const reason = error.data && error.data.reason;
        if (reason) {
          this.$alert(reason, '提示', {
            confirmButtonText: '确定',
            callback: () => {
            }
          });
          return;
        }
      });
    },

    toDetail(item) {
      console.log(this.$route, item);
      this.$router.push('/person-center/orders/farm-machinery/detail?id=' + item._id);
    },

    uploadImage (event) {
      console.log(event);
      if (event.length > 0) {
        this.dialogFormData.userInspectionPhotos = event;
      } else {
        this.dialogFormData.userInspectionPhotos = [];
      }
    },
    updateStatus(value) {
      if(value === 2) {
        this.dialogFormData.userInspectionPhotos = [];
      }
    }

  }
};
